import React from 'react';

const MapIframe = ({name, latitude, longitude, zoom, width, height }) => {
    const mapUrl = 'https://www.google.com/maps/embed/v1/place?&q='+name+'&center='+latitude+','+longitude+'&zoom='+zoom+'&key=AIzaSyDlQroQt9ajQefSBB5PiwcUNSfD1ZY8oaw';

    return (
            <iframe
                title={name}
                width={width}
                height={height}
                frameBorder="0"
                src={mapUrl}
                allowFullScreen
            ></iframe>
    );
};

export default MapIframe;
